var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 67.2,
    y: 130.8,
    width: 411.6,
    height: 247
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273,130.8c-54.9,0-89.2,27.4-102.9,82.3c20.6-27.4,44.6-37.7,72-30.9c15.7,3.9,26.8,15.3,39.2,27.8 c20.2,20.5,43.5,44.2,94.5,44.2c54.9,0,89.2-27.4,102.9-82.3c-20.6,27.4-44.6,37.7-72,30.9c-15.7-3.9-26.8-15.3-39.2-27.8 C347.4,154.5,324,130.8,273,130.8z M170.1,254.2c-54.9,0-89.2,27.4-102.9,82.3c20.6-27.4,44.6-37.7,72-30.9 c15.7,3.9,26.8,15.3,39.2,27.8c20.2,20.5,43.5,44.2,94.5,44.2c54.9,0,89.2-27.4,102.9-82.3c-20.6,27.4-44.6,37.7-72,30.9 c-15.7-3.9-26.8-15.3-39.2-27.8C244.5,277.9,221.1,254.2,170.1,254.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindWhite);
export default __webpack_public_path__ + "static/media/tailwind-white.559289ded910a03f336cf5b301ff0af7.svg";
export { ForwardRef as ReactComponent };